import { versionRequest } from '@/service/request';
import { request } from '../request';

/**
 * Login
 *
 * @param userName User name
 * @param password Password
 * @param orgCode Organization code
 */
export function fetchLogin(userName: string, password: string, orgCode?: string) {
  return request<Api.Auth.LoginToken>({
    url: '/auth/user_name',
    method: 'post',
    data: {
      userName,
      password,
      clientType: 'web',
      ...(orgCode ? { orgCode } : {})
    }
  });
}

/** user logout */
export function fetchLogout() {
  return request<boolean>({
    url: '/auth/logout',
    method: 'post'
  });
}

/** Get user info */
export function fetchGetUserInfo() {
  return request<Api.Auth.UserInfo>({ url: '/auth/user_info' });
}

/**
 * Refresh token
 *
 * @param refreshToken Refresh token
 */
export function fetchRefreshToken(refreshToken: string) {
  return request<Api.Auth.LoginToken>({
    url: '/auth/refresh_token',
    method: 'post',
    data: {
      refreshToken
    }
  });
}

/**
 * User register
 *
 * @param userName User name
 * @param password Password
 * @param confirmPassword Confirm password
 * @param realName Real name
 * @param phone Phone number
 * @param idCard ID card number
 */
export function fetchRegister(userName: string, password: string, confirmPassword: string, realName: string, phone: string, idCard: string) {
  return request<boolean>({
    url: '/auth/register',
    method: 'post',
    data: {
      userName,
      password,
      confirmPassword,
      realName,
      phone,
      idCard
    }
  });
}

/**
 * return custom backend error
 *
 * @param code error code
 * @param msg error message
 */
export function fetchCustomBackendError(code: string, msg: string) {
  return request({ url: '/auth/error', params: { code, msg } });
}

/**
 * switch org
 *
 * @param userId User ID
 * @param orgCode Organization code
 */
export function SwitchOrg(userId: string, orgCode: string) {
  return request({
    url: '/auth/switch_org',
    method: 'put',
    data: {
      userId,
      orgCode
    }
  });
}

/**
 * Upload electronic signature
 *
 * @param base64Image Base64 encoded signature image
 * @param fileType File type (png, jpg, etc.)
 */
export function fetchUploadElectronicSignature(base64Image: string, fileType: string = 'png') {
  return versionRequest<boolean>({
    url: '/sys_user/upload_electronic_signature',
    method: 'post',
    data: {
      base64Image,
      fileType
    }
  });
}

/** Get electronic signature list */
export function fetchGetElectronicSignatureList() {
  return versionRequest<Api.Auth.ElectronicSignature[]>({
    url: '/sys_user/electronic_signature/list',
    method: 'get'
  });
}

/** Get latest electronic signature */
export function fetchGetLatestElectronicSignature() {
  return versionRequest<Api.Auth.ElectronicSignature>({
    url: '/sys_user/electronic_signature/latest',
    method: 'get'
  });
}

/** 获取跳转 OA 工作台的 SSO ticket URL */
export function fetchSsoOaTicket() {
  return request<{ url: string }>({
    url: '/sso/oa/ticket',
    method: 'get'
  });
}
